'use client';

import React from 'react';

import { Row, Rows } from '@bytel/trilogy-react';

import { ProductChildFull, ProductFeatureType, ProductParentFull } from '@app-types/product';

import { CategoryBox, CustomizationCategory, Stock } from '@product-detail/components';
import { ClickEvent } from '@trilogy-ds/react/lib/events/OnClickEvent';

export type CustomizationProps = {
    features: ProductParentFull['features'];
    featuresRules: ProductParentFull['featuresRules'];
    currentProduct: ProductChildFull;
    handleProductChange: (color: string, capacity?: string) => void;
    openShopAvailabilityModal: ClickEvent;
    isRenewal: boolean;
};

export function Customization({
    features,
    featuresRules,
    currentProduct,
    handleProductChange,
    openShopAvailabilityModal,
    isRenewal,
}: CustomizationProps) {
    return (
        <CategoryBox title='Quel modèle voulez-vous&nbsp;?' formId='customizations'>
            <Rows>
                {features.color.length > 0 && (
                    <Row>
                        <CustomizationCategory
                            title='La couleur'
                            currentProduct={currentProduct}
                            featuresKey={ProductFeatureType.COLOR}
                            featuresRules={featuresRules}
                            features={features}
                            handleProductChange={handleProductChange}
                        />
                    </Row>
                )}
                {features.capacity.length > 0 && (
                    <Row>
                        <CustomizationCategory
                            title='La mémoire'
                            currentProduct={currentProduct}
                            featuresKey={ProductFeatureType.CAPACITY}
                            features={features}
                            featuresRules={featuresRules}
                            handleProductChange={handleProductChange}
                        />
                    </Row>
                )}
                <Stock currentProduct={currentProduct} openModal={openShopAvailabilityModal} isRenewal={isRenewal} />
            </Rows>
        </CategoryBox>
    );
}
